import { useGetRolesQuery } from '@/features/api/endpoints/roleEndpoints';

export const useGetFileSubmissionRecipientGroups = () => {
  return useGetRolesQuery({
    fields: ['id', 'name', 'email', 'uploadFolder'],
    filter: {
      email: {
        _nnull: true,
      },
      uploadFolder: {
        _nnull: true,
      },
    },
    sort: ['name'],
  });
};
